<template>
  <GlobalStyle>
    <div id="app">
      <router-view></router-view>
      <portal-target name="destination"></portal-target>
    </div>
  </GlobalStyle>
</template>

<script>
import GlobalStyle from "./components/style/GlobalStyle";

export default {
  name: "app",
  components: {
    GlobalStyle
  }
};

window.addEventListener("orientationchange", () => {
  //location.reload();
});
</script>